export default __webpack_public_path__ + "static/media/bayad_coming_soon.7c396002.png";